import { useContext } from 'react';
import { ApplicationContext } from '@secretescapes/cauldron';

export const useApplicationState = () => {
  const applicationState = useContext(ApplicationContext);

  if (!applicationState) {
    throw new Error('Application state context not initialized!');
  }

  return applicationState;
};
